import { investorApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const investorSchema = new schema.Entity('data', {}, { idAttribute: 'investorId' });

export const INVESTORS_ACTION_TYPE = createNamedActions('investors', {
  GET_INVESTORS: 'GET_INVESTORS',
  GET_INVESTORS_LIST: 'GET_INVESTORS_LIST',
  CREATE_INVESTOR: 'CREATE_INVESTOR',
  EDIT_INVESTOR: 'EDIT_INVESTOR',
  DELETE_INVESTOR: 'DELETE_INVESTOR',
});

export const getInvestorsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorApi.getInvestors(params);

  return dispatch({
    type: INVESTORS_ACTION_TYPE.GET_INVESTORS,
    payload: normalize(data, [investorSchema]).entities.data,
  });
});

export const getInvestorsListAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorApi.getInvestorsList(params);

  return dispatch({
    type: INVESTORS_ACTION_TYPE.GET_INVESTORS_LIST,
    payload: data.map(investor => ({ ...investor, isAvailable: true })),
  });
});

export const createInvestorAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorApi.createInvestor(params);

  return dispatch({
    type: INVESTORS_ACTION_TYPE.CREATE_INVESTOR,
    payload: data,
  });
});

export const editInvestorAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await investorApi.editInvestor(params);

  return dispatch({
    type: INVESTORS_ACTION_TYPE.EDIT_INVESTOR,
    payload: data,
  });
});

export const deleteInvestorAction = catchAsyncActionError(params => async dispatch => {
  await investorApi.deleteInvestor(params);

  return dispatch({
    type: INVESTORS_ACTION_TYPE.DELETE_INVESTOR,
    meta: params,
  });
});
